import request from '../../axios';

export const postInstallmentCardToCardPayment = async (
  payload: IPostInstallmentCardToCardPayment,
) => {
  const formData = new FormData();

  if (payload.image instanceof File) {
    formData.append('image', payload.image);
  }

  await request.post(
    `api/v2/payment/payment-installment-card-to-card/taken-loan/` +
      payload.taken_loan,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

export interface IPostInstallmentCardToCardPayment {
  taken_loan: string;
  image: File | null;
}
